import React from 'react';
import PropTypes from 'prop-types';

import {Typography} from 'views/components';
import {DescriptionOutlined as DescriptionOutlinedIcon} from 'views/icons';
import {Translate} from 'views/module';

import TimelineCard from './TimelineCard';
import moment from 'moment';

const RecordCreation = (props) => {
  const {createdAt} = props;

  const timeString = moment(createdAt).format('LLL');
  return (
    <TimelineCard
      timeString={timeString}
      icon={DescriptionOutlinedIcon}
      iconColor="#b0b0b0"
      timeBg="#e0e0e0"
      title={<Translate expression='schedule.eventDetail.EventTimelineSection.RecordCreation.Title' />}
      description={<Translate expression='schedule.eventDetail.EventTimelineSection.RecordCreation.Description' />}
    >
      <Typography variant="body2" color="text.secondary">
        <Translate
          expression='schedule.eventDetail.EventTimelineSection.RecordCreation.Description'
        />
      </Typography>
    </TimelineCard>
  );
};

RecordCreation.propTypes = {
  createdAt: PropTypes.string.isRequired,
};

export default RecordCreation;
